<template>
  <div>
    <div name="List" >
      <v-btn
              v-if="!isHidden"
              v-on:click="LoadUserAttendance(student)"
              :key="student['.key']"
              v-for="(student) in students"
      >{{student.firstName}}</v-btn>

      <!--{{loadStudent()}}-->
        <!--v-on:click="LoadUserAttendance(user)"-->
        <!--:key="user['.key']"-->
        <!--v-for="(user) in users"-->
      <!--&gt;{{user.firstName}}</v-btn>-->
    </div>
    <div v-if="isHidden">
      <p v-if="user!=''">Attendance for {{user.firstName}} on {{date}}</p>
      <v-btn v-on:click="SetAttendance('Present')">Present</v-btn>
      <v-btn v-on:click="SetAttendance('Absent')">Absent</v-btn>
      <v-btn  v-on:click="SetAttendance('Cancelled')">Cancelled</v-btn>

      <h1>User is {{attendance}}</h1>
      <v-btn color="error" v-on:click="NoPay()">No Pay</v-btn>
    </div>
  </div>
</template>
<script>
import db from "../database";
import moment from "moment";
import DataLoader from "../scripts/DataLoader";
export default {
  name: "StudentLoader",
  data() {
    return {
      isHidden: false,
      user: "",
      date: "",
      attendance: "",
      paid: "",

    };
  },
  computed: {
    timestamp: function() {
      return moment().format("DD-MM-YYYY HH:MM A");
    }
  },

  firestore() {
    return {

      users: db.collection("Users"),
        students: this.loadStudent()

    };
  },
  methods: {
    LoadUserAttendance(user) {
      this.user = user;
      this.isHidden = true;
      console.log(user.username);
      this.date = this.timestamp;
      // console.log(this.user[".key"]);
    },
      loadStudent(){
        var loader = new DataLoader();
        var studentRef = loader.GetStudents();
        // console.log(studentRef);
        return studentRef ;
      },

    SetAttendance(status) {
      console.log("status is: " + status);
      this.attendance = this.status;
      let attendance = status;
      let onlyDate = this.date.split(" ");

      this.$firestore.users
        .doc(this.user[".key"])
        .collection("Attendance")
        .doc(onlyDate[0])
        .set({ attendance: "" + attendance },{ merge: true });
      alert("Attendance Registered")
    },
    NoPay(){
      let onlyDate = this.date.split(" ");
      this.$firestore.users
              .doc(this.user[".key"])
              .collection("Attendance")
              .doc(onlyDate[0])
              .set({ Paid: "Not Paid"},{ merge: true });
    }
  }
};
</script>

